import { accountVerifiedSchema } from './Account/AccountVerifiedSchema';
import { loginSubmitSchema } from './Account/LoginSubmitSchema';
import { signupStartSchema } from './Account/SignupStartSchema';
import { signupSubmitSchema } from './Account/SignupSubmitSchema';
import { initialAttributionSchema } from './Attribution/InitialAttributionSchema';
import { latestAttributionSchema } from './Attribution/LatestAttributionSchema';
import { breadcrumbClickedSchema } from './BreadcrumbClicked/BreadcrumbClickedSchema';
import { callStartSchema } from './CallStart/CallStartSchema';
import { callSubmitSchema } from './CallSubmit/CallSubmitSchema';
import { checkboxClickedSchema } from './CheckboxEvent/CheckboxEventSchema';
import { abandonCheckoutModalSchema } from './Checkout/AbandonCheckout/AbandonCheckoutModalSchema';
import { checkoutAccountSchema } from './Checkout/Account/CheckoutAccountSchema';
import { checkoutCashSchema } from './Checkout/CheckoutCash/CheckoutCashSchema';
import { checkoutDetailsSchema } from './Checkout/CheckoutDetails/CheckoutDetailsSchema';
import { checkoutFinanceSchema } from './Checkout/CheckoutFinance/CheckoutFinanceSchema';
import { checkoutStartSchema } from './Checkout/CheckoutStart/CheckoutStartSchema';
import { checkoutSummarySchema } from './Checkout/CheckoutSummary/CheckoutSummarySchema';
import { componentViewedSchema } from './ComponentViewed/ComponentViewedSchema';
import { createAlertConfirmationSchema } from './CreateAlert/CreateAlertConfirmation/CreateAlertConfirmationSchema';
import { createAlertStartSchema } from './CreateAlert/CreateAlertStart/CreateAlertStartSchema';
import { ctaClickedSchema } from './CtaClicked/CtaClickedSchema';
import { experimentViewedSchema } from './ExperimentViewed/ExperimentViewedSchema';
import { addFavouritesSchema } from './Favourites/AddFavourites/AddFavouritesSchema';
import { filterInteractionSchema } from './FilterInteraction/FilterInteractionSchema';
import { hovStartSchema } from './Hov/HovStart/HovStartSchema';
import { hovSubmitSchema } from './Hov/HovSubmit/HovSubmitSchema';
import { image360ViewedSchema } from './Image360/Image360ViewedSchema';
import { leadSchema } from './Lead/LeadSchema';
import { leadStartSchema } from './Lead/LeadStart/LeadStartSchema';
import { leadSubmitSchema } from './Lead/LeadSubmit/LeadSubmitSchema';
import { listingSchema } from './Listing/ListingSchema';
import { listingFeatureSchema } from './ListingFeature/ListingFeatureSchema';
import { marketingSchema } from './Marketing/MarketingSchema';
import { nlsSchema } from './Nls/NlsSchema';
import { pdpViewedSchema } from './PdpViewed/PdpViewedSchema';
import { consentsSchema } from './Quantcast/Purpose/Consents/ConsentsSchema';
import { legitimateInterestsSchema } from './Quantcast/Purpose/LegitimateInterests/LegitimateInterestsSchema';
import { purposeSchema } from './Quantcast/Purpose/PurposeSchema';
import { specialFeatureOptinsSchema } from './Quantcast/SpecialFeatureOptins/SpecialFeatureOptinsSchema';
import { recentlyViewedClickSchema } from './RecentlyViewedClick/RecentlyViewedClickSchema';
import { reservationStartSchema } from './Reservation/ReservationStart/ReservationStartSchema';
import { reservationSubmitPaidSchema } from './Reservation/ReservationSubmitPaid/ReservationSubmitPaidSchema';
import { reservationSubmitDetailsSchema } from './Reservation/ReserveSubmitDetails/ReserveSubmitDetailsSchema';
import { scrollToFinanceSchema } from './ScrollToFinance/ScrollToFinanceSchema';
import { searchFiltersSchema } from './SearchFilters/SearchFiltersSchema';
import { searchResultsSchema } from './SearchResults/SearchResultsSchema';
import { searchSortSchema } from './SearchSort/SearchSortSchema';
import { userContextSchema } from './UserContext/UserContextSchema';
import { vehicleDetailsSchema } from './VehicleDetails/VehicleDetailsSchema';

export const schemas = [
  abandonCheckoutModalSchema,
  addFavouritesSchema,
  callStartSchema,
  callSubmitSchema,
  checkoutCashSchema,
  checkoutDetailsSchema,
  checkoutFinanceSchema,
  checkoutStartSchema,
  checkoutSummarySchema,
  componentViewedSchema,
  checkoutAccountSchema,
  consentsSchema,
  createAlertConfirmationSchema,
  createAlertStartSchema,
  experimentViewedSchema,
  filterInteractionSchema,
  hovStartSchema,
  hovSubmitSchema,
  initialAttributionSchema,
  latestAttributionSchema,
  leadSchema,
  leadStartSchema,
  leadSubmitSchema,
  legitimateInterestsSchema,
  listingFeatureSchema,
  listingSchema,
  marketingSchema,
  nlsSchema,
  pdpViewedSchema,
  purposeSchema,
  reservationStartSchema,
  reservationSubmitDetailsSchema,
  reservationSubmitPaidSchema,
  scrollToFinanceSchema,
  searchFiltersSchema,
  searchResultsSchema,
  searchSortSchema,
  specialFeatureOptinsSchema,
  userContextSchema,
  vehicleDetailsSchema,
  ctaClickedSchema,
  checkboxClickedSchema,
  breadcrumbClickedSchema,
  accountVerifiedSchema,
  signupStartSchema,
  signupSubmitSchema,
  loginSubmitSchema,
  image360ViewedSchema,
  recentlyViewedClickSchema,
];
